"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.companyHealthComparison_enDe = void 0;
exports.companyHealthComparison_enDe = {
    metaData: {
        prismicId: 'ZtB9qREAACoAPKn9',
        type: 'comparisontable',
        uid: 'company-health-comparison',
        lang: 'en-de',
        lastPublished: '2024-09-09T15:40:17+0000',
    },
    tableData: {
        title: 'This is your insurance',
        collapsibleSections: true,
        hideDetails: false,
        tableData: [
            {
                section: {
                    title: '',
                },
                rows: [
                    [
                        {
                            cellId: 'table_row$15fe5ec4-8228-4752-af4a-c46f55ad438d_header',
                            text: 'Coverage overview',
                            description: null,
                        },
                        {
                            cellId: 'table_row$15fe5ec4-8228-4752-af4a-c46f55ad438d_0',
                            type: 'BUTTON',
                            buttonCaption: 'Feather4You',
                            price: '300 €',
                            disabled: true,
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$d94f7224-a56c-4da9-b4a6-175e36d4ee42_header',
                            text: 'Contribution exemption',
                            description: null,
                        },
                        {
                            cellId: 'table_row$d94f7224-a56c-4da9-b4a6-175e36d4ee42_0',
                            description: '- Parental allowance\n- Nursing leave\n- for longer periods of incapacity for work',
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$2c9eb5db-0155-4661-9299-eda765b4f554_header',
                            text: 'Cover without risk assessment',
                            description: null,
                        },
                        {
                            cellId: 'table_row$2c9eb5db-0155-4661-9299-eda765b4f554_0',
                            checkmarkValue: true,
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$38ab6cca-9452-4cc5-a0b6-20721cffca4e_header',
                            text: 'Waiting period',
                            description: null,
                        },
                        {
                            cellId: 'table_row$38ab6cca-9452-4cc5-a0b6-20721cffca4e_0',
                            description: 'No waiting period',
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$3b98825b-bce8-41db-9e65-0a41c42bbd75_header',
                            text: 'Employees with private insurance',
                            description: null,
                        },
                        {
                            cellId: 'table_row$3b98825b-bce8-41db-9e65-0a41c42bbd75_0',
                            checkmarkValue: true,
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$1c5a0a61-58b2-4634-acde-b4e521c1907c_header',
                            text: 'Exclusion diganoses',
                            description: null,
                        },
                        {
                            cellId: 'table_row$1c5a0a61-58b2-4634-acde-b4e521c1907c_0',
                            description: 'none',
                        },
                    ],
                ],
            },
            {
                section: {
                    title: 'Ambulant',
                    icon: 'https://images.prismic.io/feather-website/Zt72RxoQrfVKl2vM_Ambulant.png?auto=format,compress',
                },
                rows: [
                    [
                        {
                            cellId: 'table_row$f121931f-7e17-41d9-a33b-c796e1777a95_header',
                            text: 'Reimbursement limits',
                            description: null,
                        },
                        {
                            cellId: 'table_row$f121931f-7e17-41d9-a33b-c796e1777a95_0',
                            text: '100 % up to the Budget',
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$4db2c9b3-5fe8-431d-a5e0-1bc6a86f9b0a_header',
                            text: 'Medicines and bandages Co-payments',
                            description: null,
                        },
                        {
                            cellId: 'table_row$4db2c9b3-5fe8-431d-a5e0-1bc6a86f9b0a_0',
                            checkmarkValue: true,
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$7fd8b848-0549-45d1-aa7e-0a9d4eab3ad1_header',
                            text: 'Drugs and dressings',
                            description: null,
                        },
                        {
                            cellId: 'table_row$7fd8b848-0549-45d1-aa7e-0a9d4eab3ad1_0',
                            description: 'if prescribed by a doctor',
                            checkmarkValue: true,
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$a77b06d2-f1f4-417c-b715-e8a68a9adc95_header',
                            text: 'Private recipes',
                            description: null,
                        },
                        {
                            cellId: 'table_row$a77b06d2-f1f4-417c-b715-e8a68a9adc95_0',
                            checkmarkValue: true,
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$c82b7ff6-98ff-4d4d-874f-65291f6a7fb6_header',
                            text: 'Treatment abroad',
                            description: null,
                        },
                        {
                            cellId: 'table_row$c82b7ff6-98ff-4d4d-874f-65291f6a7fb6_0',
                            description: 'European countries',
                            checkmarkValue: true,
                        },
                    ],
                ],
            },
            {
                section: {
                    title: 'Aids',
                    icon: 'https://images.prismic.io/feather-website/Zt72ZRoQrfVKl2vP_vision.png?auto=format,compress',
                },
                rows: [
                    [
                        {
                            cellId: 'table_row$0719df70-f1a7-418b-be2a-64949cf93d32_header',
                            text: 'Reimbursement limits',
                            description: null,
                        },
                        {
                            cellId: 'table_row$0719df70-f1a7-418b-be2a-64949cf93d32_0',
                            text: '100 % up to the Budget',
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$61ea8ca2-8263-4b7d-af0d-f1a36208bcff_header',
                            text: 'Aids Co-payments',
                            description: null,
                        },
                        {
                            cellId: 'table_row$61ea8ca2-8263-4b7d-af0d-f1a36208bcff_0',
                            checkmarkValue: true,
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$b0d1e78b-56bf-46d1-ac8c-8bda87811905_header',
                            text: 'Open aid directory',
                            description: null,
                        },
                        {
                            cellId: 'table_row$b0d1e78b-56bf-46d1-ac8c-8bda87811905_0',
                            checkmarkValue: true,
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$bf556f3a-62e9-490b-a962-4a6941a99a2e_header',
                            text: 'Surgery to correct defective vision e.g. LASIK',
                            description: null,
                        },
                        {
                            cellId: 'table_row$bf556f3a-62e9-490b-a962-4a6941a99a2e_0',
                            checkmarkValue: true,
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$bd036b8a-acd8-4d1e-ba6e-868037cabe26_header',
                            text: 'Pre- and post-operative check-up',
                            description: null,
                        },
                        {
                            cellId: 'table_row$bd036b8a-acd8-4d1e-ba6e-868037cabe26_0',
                            checkmarkValue: true,
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$1f02fb0e-7476-47c0-99d1-68efb99ec862_header',
                            text: 'Visual aids / contact lenses',
                            description: 'No prescription from an ophthalmologist necessary - optician with diopter value information sufficient',
                        },
                        {
                            cellId: 'table_row$1f02fb0e-7476-47c0-99d1-68efb99ec862_0',
                            checkmarkValue: true,
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$e9e42ca0-7d9c-4590-80d4-57d7c6e8d82f_header',
                            text: 'Expenses for eyeglass repairs',
                            description: null,
                        },
                        {
                            cellId: 'table_row$e9e42ca0-7d9c-4590-80d4-57d7c6e8d82f_0',
                            checkmarkValue: true,
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$0938157d-01ce-42ee-9981-73fdadb2747e_header',
                            text: 'Sunglasses with prescription',
                            description: null,
                        },
                        {
                            cellId: 'table_row$0938157d-01ce-42ee-9981-73fdadb2747e_0',
                            checkmarkValue: true,
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$3e064524-a630-46c6-9e7d-3d0a7dccb8ff_header',
                            text: 'Display screen glasses',
                            description: null,
                        },
                        {
                            cellId: 'table_row$3e064524-a630-46c6-9e7d-3d0a7dccb8ff_0',
                            checkmarkValue: true,
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$5f69ee46-99e8-4bfb-a99e-05a6bc2f45fb_header',
                            text: 'Care and cleaning products',
                            description: null,
                        },
                        {
                            cellId: 'table_row$5f69ee46-99e8-4bfb-a99e-05a6bc2f45fb_0',
                            checkmarkValue: true,
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$de21f7b6-470e-4ed7-9656-1922ddd9907d_header',
                            text: 'Hearing aids',
                            description: null,
                        },
                        {
                            cellId: 'table_row$de21f7b6-470e-4ed7-9656-1922ddd9907d_0',
                            checkmarkValue: true,
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$6e70e86b-1859-4031-b9b6-c6e055d467e3_header',
                            text: 'Bandages',
                            description: null,
                        },
                        {
                            cellId: 'table_row$6e70e86b-1859-4031-b9b6-c6e055d467e3_0',
                            checkmarkValue: true,
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$1955a283-6d94-4e3a-a7fa-ab557dccf376_header',
                            text: 'Orthopaedic shoes, insoles and compression stockings',
                            description: null,
                        },
                        {
                            cellId: 'table_row$1955a283-6d94-4e3a-a7fa-ab557dccf376_0',
                            checkmarkValue: true,
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$cf07f1ef-e5bc-49fa-b4b9-b21e4540831b_header',
                            text: 'Other aids',
                            description: null,
                        },
                        {
                            cellId: 'table_row$cf07f1ef-e5bc-49fa-b4b9-b21e4540831b_0',
                            checkmarkValue: true,
                        },
                    ],
                ],
            },
            {
                section: {
                    title: 'Remedies',
                    icon: 'https://images.prismic.io/feather-website/Zt72pBoQrfVKl2vf_Hand.png?auto=format,compress',
                },
                rows: [
                    [
                        {
                            cellId: 'table_row$067c278c-9d9b-4f27-a975-ea129e75fcd3_header',
                            text: 'Reimbursement limits',
                            description: null,
                        },
                        {
                            cellId: 'table_row$067c278c-9d9b-4f27-a975-ea129e75fcd3_0',
                            text: '100 % up to the Budget',
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$bfc28f53-da1e-41aa-8065-30532687d8ae_header',
                            text: 'Remedies Co-payments',
                            description: null,
                        },
                        {
                            cellId: 'table_row$bfc28f53-da1e-41aa-8065-30532687d8ae_0',
                            checkmarkValue: true,
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$176fadb4-0b68-4885-88fe-8ac5a7038e01_header',
                            text: 'Open directory of remedies',
                            description: null,
                        },
                        {
                            cellId: 'table_row$176fadb4-0b68-4885-88fe-8ac5a7038e01_0',
                            checkmarkValue: true,
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$816e5f40-c3aa-4f09-a6e0-f2d004a8911f_header',
                            text: 'Chiropractor',
                            description: null,
                        },
                        {
                            cellId: 'table_row$816e5f40-c3aa-4f09-a6e0-f2d004a8911f_0',
                            checkmarkValue: true,
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$f0895718-62c2-46b5-aa54-47dd9b1e8e7a_header',
                            text: 'Physiotherapy',
                            description: null,
                        },
                        {
                            cellId: 'table_row$f0895718-62c2-46b5-aa54-47dd9b1e8e7a_0',
                            checkmarkValue: true,
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$41aefa02-feb2-4a99-97ec-487df8c25b8e_header',
                            text: 'Massages',
                            description: null,
                        },
                        {
                            cellId: 'table_row$41aefa02-feb2-4a99-97ec-487df8c25b8e_0',
                            checkmarkValue: true,
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$341658ee-ad7b-4344-b53d-e704cc0f720a_header',
                            text: 'Logopedics',
                            description: null,
                        },
                        {
                            cellId: 'table_row$341658ee-ad7b-4344-b53d-e704cc0f720a_0',
                            checkmarkValue: true,
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$05a00e78-f4c1-41e8-a317-4960fd26ca8b_header',
                            text: 'Ergotherapy',
                            description: null,
                        },
                        {
                            cellId: 'table_row$05a00e78-f4c1-41e8-a317-4960fd26ca8b_0',
                            checkmarkValue: true,
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$7ed109b5-f3c9-47c1-8f0e-da87b3bf8af7_header',
                            text: 'Osteopathy',
                            description: null,
                        },
                        {
                            cellId: 'table_row$7ed109b5-f3c9-47c1-8f0e-da87b3bf8af7_0',
                            checkmarkValue: true,
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$e50e6d3b-338e-4ba9-800d-a5dd683223fd_header',
                            text: 'Kinesiotaping',
                            description: null,
                        },
                        {
                            cellId: 'table_row$e50e6d3b-338e-4ba9-800d-a5dd683223fd_0',
                            checkmarkValue: true,
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$a5a0c66c-e6b9-4ad9-a8a3-62238d84153a_header',
                            text: 'medicinal baths',
                            description: null,
                        },
                        {
                            cellId: 'table_row$a5a0c66c-e6b9-4ad9-a8a3-62238d84153a_0',
                            checkmarkValue: true,
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$18f8fc1a-fe78-4f3f-8bc1-fbf07f27e604_header',
                            text: 'Electrotherapy',
                            description: null,
                        },
                        {
                            cellId: 'table_row$18f8fc1a-fe78-4f3f-8bc1-fbf07f27e604_0',
                            checkmarkValue: true,
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$9b43069b-27cd-4df8-a083-71b848cc0fcb_header',
                            text: 'Light therapy',
                            description: null,
                        },
                        {
                            cellId: 'table_row$9b43069b-27cd-4df8-a083-71b848cc0fcb_0',
                            checkmarkValue: true,
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$6d215b5c-821c-421d-ad0a-d8fd9de0f11d_header',
                            text: 'Nutritional therapy',
                            description: null,
                        },
                        {
                            cellId: 'table_row$6d215b5c-821c-421d-ad0a-d8fd9de0f11d_0',
                            checkmarkValue: true,
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$eb813492-4665-46b9-b205-abf31ef87834_header',
                            text: 'Medical pedicure (podiatry)',
                            description: null,
                        },
                        {
                            cellId: 'table_row$eb813492-4665-46b9-b205-abf31ef87834_0',
                            checkmarkValue: true,
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$4e40e214-9295-45db-9173-f771c7a67261_header',
                            text: 'Therapeutic horse riding (hippotherapy)',
                            description: null,
                        },
                        {
                            cellId: 'table_row$4e40e214-9295-45db-9173-f771c7a67261_0',
                            checkmarkValue: true,
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$abc86d2a-8fc5-457c-a404-1e34ad7951ae_header',
                            text: 'Pregnancy gymnastics',
                            description: null,
                        },
                        {
                            cellId: 'table_row$abc86d2a-8fc5-457c-a404-1e34ad7951ae_0',
                            checkmarkValue: true,
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$7be98ff0-15fb-42dc-9358-4f280b23b5d3_header',
                            text: 'Respiratory treatment',
                            description: null,
                        },
                        {
                            cellId: 'table_row$7be98ff0-15fb-42dc-9358-4f280b23b5d3_0',
                            checkmarkValue: true,
                        },
                    ],
                ],
            },
            {
                section: {
                    title: 'Naturopathy',
                    icon: 'https://images.prismic.io/feather-website/Zt72xBoQrfVKl2vl_Natural.png?auto=format,compress',
                },
                rows: [
                    [
                        {
                            cellId: 'table_row$d2fd4e90-4257-42fc-bd9a-7f453a207a0d_header',
                            text: 'Reimbursement limits',
                            description: null,
                        },
                        {
                            cellId: 'table_row$d2fd4e90-4257-42fc-bd9a-7f453a207a0d_0',
                            text: '100 % up to the Budget',
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$6b5f747c-6c3f-45a6-a84f-8a6c425a361c_header',
                            text: 'Naturopathic treatment by naturopaths',
                            description: null,
                        },
                        {
                            cellId: 'table_row$6b5f747c-6c3f-45a6-a84f-8a6c425a361c_0',
                            text: 'Fee schedule for alternative practitioners (GebüH)',
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$01a5340d-c538-4800-b270-238079ee29f1_header',
                            text: 'Non-medical practitioner for psychotherapy',
                            description: null,
                        },
                        {
                            cellId: 'table_row$01a5340d-c538-4800-b270-238079ee29f1_0',
                            checkmarkValue: false,
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$f9f80cf6-e6d2-49e3-a556-55ebee27dac6_header',
                            text: 'Naturopathic treatment by doctors',
                            description: null,
                        },
                        {
                            cellId: 'table_row$f9f80cf6-e6d2-49e3-a556-55ebee27dac6_0',
                            checkmarkValue: true,
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$8e250fae-5ec2-4e0b-bc40-de94d1f5d381_header',
                            text: 'Billing according to Hufeland directory',
                            description: null,
                        },
                        {
                            cellId: 'table_row$8e250fae-5ec2-4e0b-bc40-de94d1f5d381_0',
                            checkmarkValue: true,
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$3c6ef9eb-6ced-47a7-8767-cd9bb78b4129_header',
                            text: 'Medicines/supplements/remedies',
                            description: null,
                        },
                        {
                            cellId: 'table_row$3c6ef9eb-6ced-47a7-8767-cd9bb78b4129_0',
                            checkmarkValue: true,
                        },
                    ],
                ],
            },
            {
                section: {
                    title: 'Dental',
                    icon: 'https://images.prismic.io/feather-website/Zt722BoQrfVKl2vs_Dental.png?auto=format,compress',
                },
                rows: [
                    [
                        {
                            cellId: 'table_row$5a8733dc-c79d-414c-b980-cb9460817ee5_header',
                            text: 'Reimbursement limits',
                            description: null,
                        },
                        {
                            cellId: 'table_row$5a8733dc-c79d-414c-b980-cb9460817ee5_0',
                            text: '100 % after advance payment GKV/PKV up to the budget',
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$feb38aa2-e7c7-4274-871f-591e2dc03e30_header',
                            text: 'Allocation in the year of service',
                            description: null,
                        },
                        {
                            cellId: 'table_row$feb38aa2-e7c7-4274-871f-591e2dc03e30_0',
                            checkmarkValue: true,
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$8eea9832-0369-48c3-b270-30c3558aeaef_header',
                            text: 'Allocation in the year of invoicing',
                            description: null,
                        },
                        {
                            cellId: 'table_row$8eea9832-0369-48c3-b270-30c3558aeaef_0',
                            checkmarkValue: false,
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$26ad595b-846e-4dbc-bfd6-f03341e93b42_header',
                            text: 'Consultations reimbursable',
                            description: null,
                        },
                        {
                            cellId: 'table_row$26ad595b-846e-4dbc-bfd6-f03341e93b42_0',
                            checkmarkValue: true,
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$9b966dc7-a276-4030-8590-63413eb72e48_header',
                            text: 'Treatment and cost plans reimbursable',
                            description: null,
                        },
                        {
                            cellId: 'table_row$9b966dc7-a276-4030-8590-63413eb72e48_0',
                            checkmarkValue: true,
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$d4324271-208c-4229-b502-36772e500792_header',
                            text: 'Anesthesia',
                            description: null,
                        },
                        {
                            cellId: 'table_row$d4324271-208c-4229-b502-36772e500792_0',
                            checkmarkValue: true,
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$e292c63b-6892-4c0b-9040-2b8a141e85ce_header',
                            text: 'X-rays',
                            description: null,
                        },
                        {
                            cellId: 'table_row$e292c63b-6892-4c0b-9040-2b8a141e85ce_0',
                            checkmarkValue: true,
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$320f5213-a7c4-4e00-bc44-ed21462a86ad_header',
                            text: 'Dental services (material and laboratory)',
                            description: null,
                        },
                        {
                            cellId: 'table_row$320f5213-a7c4-4e00-bc44-ed21462a86ad_0',
                            checkmarkValue: true,
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$9638c5e9-b0cc-4283-8378-41c5a8b007b7_header',
                            text: 'payment above GOZ and GOÄ',
                            description: null,
                        },
                        {
                            cellId: 'table_row$9638c5e9-b0cc-4283-8378-41c5a8b007b7_0',
                            description: 'Up to the maximum rate of 3,5',
                            checkmarkValue: false,
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$e367df83-183f-4e5b-bdf8-be958736bf39_header',
                            text: 'Pain and anxiety-relieving measures e.g. hypnosis',
                            description: null,
                        },
                        {
                            cellId: 'table_row$e367df83-183f-4e5b-bdf8-be958736bf39_0',
                            checkmarkValue: true,
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$cb10d82a-603f-4355-aa74-4be01cf369bf_header',
                            text: 'Waiver of treatment and cost plan',
                            description: null,
                        },
                        {
                            cellId: 'table_row$cb10d82a-603f-4355-aa74-4be01cf369bf_0',
                            checkmarkValue: true,
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$f34071d1-26b0-4d7c-bd50-d48b2ec5cc65_header',
                            text: 'Plastic and composite fillings',
                            description: null,
                        },
                        {
                            cellId: 'table_row$f34071d1-26b0-4d7c-bd50-d48b2ec5cc65_0',
                            checkmarkValue: true,
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$795b996d-f885-4b92-86a5-6d6a3dafa68d_header',
                            text: 'Root treatment',
                            description: null,
                        },
                        {
                            cellId: 'table_row$795b996d-f885-4b92-86a5-6d6a3dafa68d_0',
                            checkmarkValue: true,
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$a69d5b56-9755-4d85-82d9-271e8d8d9073_header',
                            text: 'Periodontal services',
                            description: null,
                        },
                        {
                            cellId: 'table_row$a69d5b56-9755-4d85-82d9-271e8d8d9073_0',
                            checkmarkValue: true,
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$bd98050f-bf40-4baa-8390-58ff2b46dcfd_header',
                            text: 'DROS splint',
                            description: 'example costs approx. 3,400 €',
                        },
                        {
                            cellId: 'table_row$bd98050f-bf40-4baa-8390-58ff2b46dcfd_0',
                            checkmarkValue: true,
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$bf7babb5-e588-4f37-a821-1e76dcff3a24_header',
                            text: 'Biting aids',
                            description: null,
                        },
                        {
                            cellId: 'table_row$bf7babb5-e588-4f37-a821-1e76dcff3a24_0',
                            checkmarkValue: true,
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$56e9943b-406f-4e2c-9a3a-98beadf91e1b_header',
                            text: 'Functional analysis for tooth preservation',
                            description: null,
                        },
                        {
                            cellId: 'table_row$56e9943b-406f-4e2c-9a3a-98beadf91e1b_0',
                            checkmarkValue: true,
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$3d3c2099-f5fa-4bfa-b194-f3afdabcf493_header',
                            text: 'Dental services for prophylaxis',
                            description: null,
                        },
                        {
                            cellId: 'table_row$3d3c2099-f5fa-4bfa-b194-f3afdabcf493_0',
                            text: '100 % up to the Budget',
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$05139589-ba90-46af-b3ec-5d2efd85ca26_header',
                            text: 'Dental prophylaxis / PZR',
                            description: null,
                        },
                        {
                            cellId: 'table_row$05139589-ba90-46af-b3ec-5d2efd85ca26_0',
                            checkmarkValue: true,
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$5c4ea8cd-9420-4376-842b-32e57c5599b6_header',
                            text: 'Sealing (fissure sealing)',
                            description: null,
                        },
                        {
                            cellId: 'table_row$5c4ea8cd-9420-4376-842b-32e57c5599b6_0',
                            checkmarkValue: true,
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$ae7bdc66-32ab-4cbc-b9a4-0bdba339e3a1_header',
                            text: 'Expenses for the prevention of dental diseases',
                            description: null,
                        },
                        {
                            cellId: 'table_row$ae7bdc66-32ab-4cbc-b9a4-0bdba339e3a1_0',
                            checkmarkValue: true,
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$3a3f709d-45c1-4b76-9111-26cbf43303ee_header',
                            text: 'Fluoridation',
                            description: null,
                        },
                        {
                            cellId: 'table_row$3a3f709d-45c1-4b76-9111-26cbf43303ee_0',
                            checkmarkValue: true,
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$4c23a879-fe4c-4b2e-b9f1-59d80557017d_header',
                            text: 'Bleaching / tooth whitening measures',
                            description: null,
                        },
                        {
                            cellId: 'table_row$4c23a879-fe4c-4b2e-b9f1-59d80557017d_0',
                            checkmarkValue: false,
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$6b576953-2fc8-4d61-9ae2-c87a88ff67ef_header',
                            text: 'Dentures, e.g. crowns, bridges, full and partial dentures',
                            description: 'e.g. pin teeth',
                        },
                        {
                            cellId: 'table_row$6b576953-2fc8-4d61-9ae2-c87a88ff67ef_0',
                            checkmarkValue: true,
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$7bf02197-a0d7-4bff-ba7f-c7edd6088321_header',
                            text: 'Implants',
                            description: null,
                        },
                        {
                            cellId: 'table_row$7bf02197-a0d7-4bff-ba7f-c7edd6088321_0',
                            checkmarkValue: true,
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$a7dc4a7f-c0b8-427b-90b0-9efbc7c26509_header',
                            text: 'Bone augmentation for implant restoration',
                            description: null,
                        },
                        {
                            cellId: 'table_row$a7dc4a7f-c0b8-427b-90b0-9efbc7c26509_0',
                            checkmarkValue: true,
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$1de85922-7afb-4172-ac2a-f906c0d3b33d_header',
                            text: 'Inlays, Onlays',
                            description: null,
                        },
                        {
                            cellId: 'table_row$1de85922-7afb-4172-ac2a-f906c0d3b33d_0',
                            checkmarkValue: true,
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$f6b10ac2-74a6-4fa6-a975-55db1da10230_header',
                            text: 'Artificial and ceramic veneers',
                            description: null,
                        },
                        {
                            cellId: 'table_row$f6b10ac2-74a6-4fa6-a975-55db1da10230_0',
                            checkmarkValue: true,
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$3968e42b-426c-465c-8d39-236adc690c7b_header',
                            text: 'Functional analysis for dentures',
                            description: null,
                        },
                        {
                            cellId: 'table_row$3968e42b-426c-465c-8d39-236adc690c7b_0',
                            checkmarkValue: true,
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$2a234696-308f-4144-b4df-50944dd03fc3_header',
                            text: 'Orthodontics before the age of 18',
                            description: null,
                        },
                        {
                            cellId: 'table_row$2a234696-308f-4144-b4df-50944dd03fc3_0',
                            checkmarkValue: true,
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$8f5dee3f-9b83-43bb-8b44-5b40140d3f8a_header',
                            text: 'Mini, ceramic or plastic brackets',
                            description: null,
                        },
                        {
                            cellId: 'table_row$8f5dee3f-9b83-43bb-8b44-5b40140d3f8a_0',
                            checkmarkValue: true,
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$cedd38dc-1c54-4e73-a22e-578d86258865_header',
                            text: 'colorless sheets',
                            description: null,
                        },
                        {
                            cellId: 'table_row$cedd38dc-1c54-4e73-a22e-578d86258865_0',
                            checkmarkValue: true,
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$71e5c330-8f6c-47a6-ac65-e2b2c5070d8f_header',
                            text: 'Lingual technique (brackets are located on the inside of the tooth)',
                            description: null,
                        },
                        {
                            cellId: 'table_row$71e5c330-8f6c-47a6-ac65-e2b2c5070d8f_0',
                            checkmarkValue: true,
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$b2545b6e-0b22-470b-885f-98cea18b01f8_header',
                            text: 'Fixed or removable retainer',
                            description: null,
                        },
                        {
                            cellId: 'table_row$b2545b6e-0b22-470b-885f-98cea18b01f8_0',
                            checkmarkValue: true,
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$a4e69f89-3375-4462-bb30-a69442ff4128_header',
                            text: 'Invisible braces',
                            description: 'e.g. Invisalign',
                        },
                        {
                            cellId: 'table_row$a4e69f89-3375-4462-bb30-a69442ff4128_0',
                            checkmarkValue: true,
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$25947823-4e9f-46cd-b3b8-174737c989c7_header',
                            text: 'Orthodontics in the event of an accident',
                            description: null,
                        },
                        {
                            cellId: 'table_row$25947823-4e9f-46cd-b3b8-174737c989c7_0',
                            checkmarkValue: true,
                        },
                    ],
                ],
            },
            {
                section: {
                    title: 'Vaccinations',
                    icon: 'https://images.prismic.io/feather-website/Zt73CRoQrfVKl2v9_Vax.png?auto=format,compress',
                },
                rows: [
                    [
                        {
                            cellId: 'table_row$3ede9f04-e07c-4d9f-b9ef-3ec70f7d1ed1_header',
                            text: 'STIKO-recommended vaccinations',
                            description: 'e.g. TBE, yellow fever, hepatitis, Japanese encephalisitis or malaria prophylaxis',
                        },
                        {
                            cellId: 'table_row$3ede9f04-e07c-4d9f-b9ef-3ec70f7d1ed1_0',
                            checkmarkValue: true,
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$558bd3d0-9263-4b4b-8495-0263fdd3b711_header',
                            text: 'Vaccinations independent of the STIKO recommendation',
                            description: null,
                        },
                        {
                            cellId: 'table_row$558bd3d0-9263-4b4b-8495-0263fdd3b711_0',
                            checkmarkValue: true,
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$b2da68a6-fccd-4bbf-981d-b4dc3e62ee5f_header',
                            text: 'Vaccinations as prophylaxis for trips abroad',
                            description: null,
                        },
                        {
                            cellId: 'table_row$b2da68a6-fccd-4bbf-981d-b4dc3e62ee5f_0',
                            checkmarkValue: true,
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$fdb75058-945b-46ad-ab3a-a51586570b78_header',
                            text: 'Vaccinations to which the employer is obliged',
                            description: null,
                        },
                        {
                            cellId: 'table_row$fdb75058-945b-46ad-ab3a-a51586570b78_0',
                            checkmarkValue: true,
                        },
                    ],
                ],
            },
        ],
    },
};
